import axios from './axios/config';

export const getActivityLogs = async ({ page, take, formData }) => {
    const res = await axios.post(`activity-log?page=${page}&size=${take}`, formData);
    return res.data;
}
